import { Box, Tabs as MantineTabs } from '@mantine/core';
import cx from 'clsx';
import { ReactElement, ReactNode } from 'react';

import classes from './Tabs.module.scss';
import { FlexAlignment } from '../../../common/themes/theme';

export type TabsProps = {
  children: ReactNode;
  tabs: {
    value: string;
    text: ReactElement | string;
  }[];
  onChange?: (value: string | null) => void;
  value?: string | null;
  panelCustomClassName?: string;
  keepTabsMounted?: boolean;
  dataTestidPrefix?: string;
  alignment?: FlexAlignment;
  type?: 'main' | 'inner';
};

export function Tabs(props: TabsProps) {
  const {
    children,
    tabs,
    value,
    onChange,
    panelCustomClassName,
    keepTabsMounted = true,
    dataTestidPrefix = 'widget-config',
    alignment = 'center',
    type = 'main'
  } = props;

  return (
    <MantineTabs
      style={{
        '--alignment': alignment,
        '--fontSize': type === 'inner' ? 14 : 16,
        '--paddingBlock': type === 'inner' ? 4 : 12
      }}
      classNames={{
        root: classes.tabsRoot,
        list: classes.tabsList,
        tabLabel: classes.tabLabel,
        tab: classes.tab
      }}
      variant="pills"
      radius="xs"
      defaultValue={tabs[0].value}
      onChange={onChange}
      value={value}
      keepMounted={keepTabsMounted}
    >
      {tabs.length > 1 && (
        <MantineTabs.List>
          {tabs.map(tab => (
            <MantineTabs.Tab
              key={tab.value}
              value={tab.value}
              data-testid={`${dataTestidPrefix ? dataTestidPrefix + '-' : ''}${tab.value}`}
            >
              {tab.text}
            </MantineTabs.Tab>
          ))}
        </MantineTabs.List>
      )}
      <Box className={cx(classes.tabsPanels, panelCustomClassName)}>{children}</Box>
    </MantineTabs>
  );
}
